import jwt_decode from 'jwt-decode';
import store from 'store2';
import { AUTH_CONFIG_DONE_KEY, AUTH_TIME_DIFF_KEY, AUTH_TOKEN_KEY, LINKS } from '../constants';
import { toCamelCase } from '../utils/formatters';
import { setLoginReferer } from './clientStorage';
import { isCSR, isLocalEnv } from './domain';
import { getBACNumberFromJWT, decodeJwt } from '../utils/jwt';
export const getAccessToken = () => {
    const authToken = store(AUTH_TOKEN_KEY);
    return authToken === null || authToken === void 0 ? void 0 : authToken.access_token;
};
export const getRefreshToken = () => {
    const authToken = store(AUTH_TOKEN_KEY);
    return authToken === null || authToken === void 0 ? void 0 : authToken.refresh_token;
};
export const storeAuthToken = (token) => {
    store(AUTH_TOKEN_KEY, token);
    if (token) {
        try {
            const { iat } = jwt_decode(token.access_token);
            const timeDiff = Date.now() / 1000 - iat;
            store(AUTH_TIME_DIFF_KEY, timeDiff);
        }
        catch (e) {
            // eslint-disable-next-line no-console
            console.error('unable to get jwt issue time to calculate time diff');
        }
    }
};
/**
 * Stores `auth_config_done` to localStorage
 *
 * Supports legacy system (OBS) and Amazon Cognito
 *
 * Should be removed after OBS shutdown
 *
 * @see https://gitlab.com/raisin-global/raisin-gmbh/banking/raisin-frontend/-/blob/master/src/utils/Auth/index.js
 */
export const storeAuthConfigDone = (value) => {
    store(AUTH_CONFIG_DONE_KEY, value);
};
/**
 * The function get the JWT from the local storage,
 * decode the JWT, and parse it to `Customer` object,
 * If there is no jwt in the local storage will return null.
 *
 * @returns {Customer} customer details object
 */
export const getCustomerFromToken = (accessToken) => {
    var _a;
    try {
        const token = accessToken || getAccessToken();
        const decodedToken = jwt_decode(token);
        const customer = toCamelCase(decodedToken);
        return Object.assign(Object.assign({}, customer), { userId: decodedToken.sub, bacNumber: (_a = decodedToken.bac_number) === null || _a === void 0 ? void 0 : _a[0] });
    }
    catch (_) {
        return null;
    }
};
export const isAnonymousUser = () => !getAccessToken();
export const loginIfAnonymous = () => {
    if (isAnonymousUser() && isCSR()) {
        window.location.assign(LINKS.LOGIN);
        return true;
    }
    return false;
};
function redirectToLogin() {
    // SSR
    if (typeof window === 'undefined')
        return;
    if (process.env.NODE_ENV !== 'development' || !isLocalEnv) {
        setLoginReferer({
            refererLink: window.location.pathname + window.location.search + window.location.hash,
        });
        window.location.assign(LINKS.LOGIN);
    }
    // This point will never be reached in a non-development environment
    // because the code execution stops and the page is redirected.
    // eslint-disable-next-line no-console
    console.debug('The customer is not logged in. In a real environment, this will result in a redirect to the login page, but locally please set a customer token manually.');
}
export const isAccessTokenExpired = () => {
    try {
        const auth = store(AUTH_TOKEN_KEY);
        const timeDelta = Number(store(AUTH_TIME_DIFF_KEY));
        const token = auth === null || auth === void 0 ? void 0 : auth.access_token;
        if (!token)
            return true;
        const { exp } = decodeJwt(token);
        const expiryEpoch = (exp + timeDelta) * 1000;
        return Number.isNaN(expiryEpoch) || Date.now() > expiryEpoch;
    }
    catch (error) {
        return true;
    }
};
export const isCustomerLoggedIn = () => !isAccessTokenExpired();
export const isAuthenticated = () => isCustomerLoggedIn();
export function useCustomerIdOrLogin() {
    return isCustomerLoggedIn() ? getBACNumberFromJWT() : redirectToLogin();
}
//# sourceMappingURL=auth.js.map